import { ref } from 'vue';

// Create shared state across components
const entry = ref(null);

/**
 * Composable for handling routine functionality
 * This replaces the Routine mixin
 */
export const useRoutine = () => {
  // Helper function to parse exercise properties
  const parseExerciseProperties = (properties) => {
    if (properties && properties.length) {
      return properties.map((prop) => prop.title).join(', ');
    }
    return '';
  };

  return {
    // State
    entry,

    // Methods
    parseExerciseProperties,
  };
};
